import { customElement } from "lit/decorators.js";

import { BaseSocialButton } from "./base-social-button";

import { googleLogoTemplate } from "../social-logos/google-logo";

@customElement("google-login-button")
export class GoogleLoginButton extends BaseSocialButton {
  constructor() {
    super();
    this.provider = "google";
  }

  protected override renderContent() {
    return googleLogoTemplate;
  }
}
